/* eslint-disable  */
//@ts-nocheck

'use strict';

import React from 'react';
import _ from 'underscore';
import VideoPlayer from 'react-hls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlay } from '@fortawesome/free-solid-svg-icons';

import NameAutocomplete from './NameAutocomplete';
import ExerciseEditHeader from './ExerciseEditHeader';
import VideoLibraryModal from './VideoLibraryModal';

class ClassExerciseEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLibraryOpen: false,
      shouldPlayVideo: false,
    };
    this.merge = this.merge.bind(this);
    this.descriptionChanged = this.descriptionChanged.bind(this);
    this.nameChanged = this.nameChanged.bind(this);
    this.onToggleMinimize = this.onToggleMinimize.bind(this);
    this.closeVideoLibraryModal = this.closeVideoLibraryModal.bind(this);
    this.openVideoLibraryModal = this.openVideoLibraryModal.bind(this);
    this.addFromVideoLibrary = this.addFromVideoLibrary.bind(this);
    this.playVideo = this.playVideo.bind(this);
  }

  merge(videoExerciseData) {
    let data = _.extend(this.props.data, videoExerciseData);
    this.props.onChange(this.props.id, data);
  }

  playVideo() {
    this.setState({
      shouldPlayVideo: true,
    });
  }

  descriptionChanged(description: string) {
    this.merge({ description: allowString(description) });
  }

  onToggleMinimize() {
    if (this.props.minimizeDisabled) return;
    this.merge({ minimized: !this.props.data.minimized });
  }

  nameChanged(name) {
    this.merge({ name });
  }

  openVideoLibraryModal() {
    this.setState({
      isLibraryOpen: true,
    });
  }

  closeVideoLibraryModal() {
    this.setState({
      isLibraryOpen: false,
    });
  }

  addFromVideoLibrary(videoExerciseObject) {
    const videoExerciseData = Object.assign({}, videoExerciseObject);
    videoExerciseData.name = this.props.data.name
      ? this.props.data.name
      : videoExerciseData && videoExerciseData.title
      ? videoExerciseData.title
      : null;
    videoExerciseData.description = allowString(
      this.props.data.description
        ? this.props.data.description
        : videoExerciseData && videoExerciseData.description
        ? videoExerciseData.description
        : null,
    );
    videoExerciseData.type = 4;
    videoExerciseData.youtubeId = '00000000000';
    videoExerciseData.media = {
      image: videoExerciseData.thumbnail,
      width: videoExerciseData.width,
      height: videoExerciseData.height,
      cdn01: '',
      video: '',
      source: '',
      mimeType: 'image/png',
    };

    delete videoExerciseData.title;
    delete videoExerciseData.uploadLink;
    delete videoExerciseData.filesize;
    delete videoExerciseData.status;
    delete videoExerciseData.fileSize;
    delete videoExerciseData.deletedAt;

    this.props.onChange(this.props.id, videoExerciseData);
  }

  render() {
    if (this.props && this.props.data && this.props.data.videoId) {
      this.props.data.id = this.props.data.videoId;
      delete this.props.data.videoId;
    }

    const videoViewer =
      this.props &&
      this.props.data &&
      (this.props.data?.video || this.props.data.media?.videoUrl) ? (
        <div style={{ position: 'relative' }}>
          {this.state.shouldPlayVideo ? (
            <VideoPlayer
              url={this.props.data?.video || this.props.data.media?.videoUrl}
              videoProps={{ autoPlay: true }}
            />
          ) : (
            <img
              src={
                this.props.data.thumbnail ||
                this.props.data.media.videoThumbnailUrl
              }
              style={{
                height: '15rem',
                width: '400px',
                borderRadius: '5px',
                objectFit: 'contain',
                backgroundColor: '#000',
              }}
            />
          )}
          <FontAwesomeIcon
            onClick={this.playVideo}
            icon={faPlay}
            style={{
              display: this.state.shouldPlayVideo ? 'none' : 'inline-block',
              position: 'absolute',
              top: '50%',
              left: '13rem',
              transform: 'translate(-50%, -50%)',
              color: '#fff',
              fontSize: '2rem',
              cursor: 'pointer',
            }}
          />
          <FontAwesomeIcon
            icon={faTrash}
            onClick={() => this.props.onRemoveVideo(this.props.id)}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '7rem',
              cursor: 'pointer',
            }}
          />
        </div>
      ) : (
        <div className="box">
          <div className="button-box">
            <button
              className="button green-button"
              onClick={this.openVideoLibraryModal}
            >
              Add from Library
            </button>
          </div>
        </div>
      );

    const content = (
      <div className="workoutForm">
        <div className="trinity">
          <div className="first">
            <label>
              Video title<strong className="warning">*</strong>
            </label>
            <NameAutocomplete
              value={this.props.data.name}
              onChange={(e) => {
                if (e && e.name) {
                  this.nameChanged(e.name);
                }
                if (e && e.description) {
                  this.descriptionChanged(e.description);
                }
                this.nameChanged(e.name);
              }}
              placeholder="Enter video title"
              maxLength={60}
            />
            <label>Video description</label>
            <textarea
              value={
                this.props.data.description ? this.props.data.description : ''
              }
              rows={3}
              cols={80}
              maxLength={2000}
              onChange={(e) => this.descriptionChanged(e.target.value)}
              placeholder="Enter description"
            />
          </div>
          <div className="second">
            <label>
              Video <strong className="warning">*</strong>
            </label>
            {videoViewer}
          </div>
        </div>
      </div>
    );
    return (
      <div className="youtubeExerciseEdit">
        <ExerciseEditHeader
          id={this.props.id}
          exerciseLength={this.props.exerciseLength}
          index={this.props.index}
          data={this.props.data}
          minimizeDisabled={this.props.minimizeDisabled}
          deleteDisabled={this.props.deleteDisabled}
          onToggleMinimize={this.onToggleMinimize}
          onDelete={this.props.onDelete}
          onMoveUp={this.props.onMoveUp}
          onMoveDown={this.props.onMoveDown}
        />
        {this.props.data.minimized ? '' : content}
        <VideoLibraryModal
          source={'Workout'}
          addFromLibrary={this.addFromVideoLibrary}
          isLibraryOpen={this.state.isLibraryOpen}
          influencerId={this.props.influencerId}
          closeLibrary={this.closeVideoLibraryModal}
        />
      </div>
    );
  }
}

export default ClassExerciseEdit;

function allowString(x: any): string {
  if (typeof x === 'string') {
    return x;
  } else {
    return '';
  }
}
